import { PropsWithChildren } from "react";

import { CentrifugeContext } from "./centrifuge-context";
import { useCentrifugeClient } from "./useCentrifugeClient";

const Provider = ({ children }: PropsWithChildren) => {
  const { client } = useCentrifugeClient();

  return <CentrifugeContext.Provider value={{ client }}>{children}</CentrifugeContext.Provider>;
};

export { Provider };
